import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const imageDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Checks whether background of Image is transparent
     * @return {Promise<boolean>}
     */
    isTransparent: async () => (await base.attr('data-transparent')) === 'true',
  };
};
